import { IntlShape } from 'react-intl';

export const dictionary = {
    movie_set_planned_to_watch: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.b050aa81ebafe8bc9feea643749fd1ca',
            defaultMessage: 'Added to "Watch later"',
            description: 'Сообщение об успешном добавлении в раздел «Буду смотреть»',
        }),
    movie_remove_planned_to_watch: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.ffc98b4edaa5bf77b4613bf50fd3a4bc',
            defaultMessage: 'Removed from "Watch later"',
            description: 'Сообщение об успешном удалении из раздела «Буду смотреть»',
        }),
    footer_support_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.Footer.17a3c546a3da10937ea4926d9f11203d',
            defaultMessage: "We're always here to help you",
            description: 'Текст поддержки в футере',
        }),
    footer_contact_support_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.support-chat.ad119d5ea30f6c26b58e0af5bc43c9fe',
            defaultMessage: 'Contact support',
            description: 'Текст ссылки на страницу поддержки',
        }),
    footer_legal_link: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.client-config.7c88d216d3e2dde1a47cb0ebc87afad2',
            defaultMessage: 'Agreement',
            description: 'Текст ссылки на пользовательское соглашение в футере',
        }),
    navigation_aria_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.header.4d7a3b1c46041dc73dec5764f3a6b63a',
            defaultMessage: 'Main menu',
            description: 'Подпись ARIA для главного меню',
        }),
    search_button_aria_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.Header.13348442cc6a27032d2b4aa28b75a5d3',
            defaultMessage: 'Search',
            description: 'aria-label для кнопки поиска в шапке сайта',
        }),
    search_close_button_aria_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.header.a462ef1c04901e8b0f276c76c1b683c8',

            defaultMessage: 'Close search',
            description: 'Лейбл кнопки закрытия поиска',
        }),
    allplay__nav_my_tooltip: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'allplay.nav_my_tooltip',
            defaultMessage: 'All your movies are here now',
            description:
                'Текст подсказки для пункта меню «Моё» в шапке, указывающий, что все фильмы пользователя доступны теперь здесь',
        }),
    menu__my_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'containers.Header.8466fa8e428bf83c4d2d9893b4bada64',
            defaultMessage: 'My',
            description: 'Название пункта меню Моё',
        }),
    menu__channels_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'containers.Header.546ba086eaa37e30303fd8e364b57bd7',
            defaultMessage: 'TV Channels',
            description: 'Заголовок вкладки каналов в хедере',
        }),
    menu__movies_and_series_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'containers.Header.6fc35dc7032157099e665b1ce06e07ef',
            defaultMessage: 'Movies and series',
            description: 'Название пункта меню главное',
        }),
    menu__home_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'containers.Header.8cf04a9734132302f96da8e113e80ce5',
            defaultMessage: 'Home',
            description: 'Название пункта меню главное',
        }),
    menu__home_hint: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'containers.Header.217ae53695739bd7250102ebc463763f',
            defaultMessage: 'All movies and series are here',
            description: 'Hint for the Main tab',
        }),
    menu__live_tv_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'containers.Header.92bf426d57bcbdf4c5559e5b7dd18902',
            defaultMessage: 'Live TV',
            description: 'Заголовок вкладки каналов в хедере',
        }),
    menu__my_collection_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'containers.Header.f0ebb2240a57f4115b3ce841d5218fa2',
            defaultMessage: 'My Collection',
            description: 'Название пункта меню Моё',
        }),
    menu__music_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'containers.Header.47dcbd834e669233d7eb8a51456ed217',
            defaultMessage: 'Music',
            description: 'Название пункта меню в шапке. Ведет на лендинг Yango Play Music.',
        }),
    menu__yasmina_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'containers.Header.ac10af5ec133bfa6b331ff1dacb4f5a8',
            defaultMessage: 'Yasmina',
            description: 'Название пункта меню в шапке. Ведет на лендинг AI-помощника Yasmina.',
        }),
    menu__crunchyroll_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'containers.Header.232a31b9112b826d55d7135cd5e0c3b1',
            defaultMessage: 'Crunchyroll',
            description: 'Название пункта меню Crunchyroll',
        }),
    menu__crunchyroll_hint: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'containers.Header.a3fd38d2fafa0ddc7771e5fa6a855469',
            defaultMessage: 'Hey otakus, your anime is here',
            description: 'Hint for Crunchyroll tab',
        }),
    menu__sport_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'app.i18n.918e180e06b96c76b7193c9fcb1cb312',
            defaultMessage: 'Sports',
            description: 'Заголовок вкладки спорта в хедере',
        }),
    promocode__button_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.header.0ab608f7e0d1501be457f7646c1e57c0',
            defaultMessage: 'Promo code',
            description: 'Текст кнопки/ссылки перехода на страницу с вводом промокодом',
        }),
    header__subscription_button_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.header.dfa592421ec2584a960f077610eb19bd',
            defaultMessage: 'Subscribe now',
            description: 'Кнопка "Подписаться" в шапке',
        }),
    footer__selection_section_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'app.i18n.f20658650d987d31063b593c05980397',
            defaultMessage: 'Watch',
            description: 'Title of the selection list in the footer',
        }),
    footer__best_selections_link: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'app.i18n.dc716766b2a1552990eebecfa7ea6a64',
            defaultMessage: 'Best Selections',
            description: 'Text on best selections link',
        }),
    footer__also_section_title: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'app.i18n.42abffbc5d25b95999d3a6af71f31e74',
                defaultMessage: 'Also with {brandName}',
                description: 'Title of the Also section in the footer',
            },
            { brandName }
        ),
    footer__other_section_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'app.i18n.6311ae17c1ee52b36e68aaf4ad066387',
            defaultMessage: 'Other',
            description: 'Title of the Other section in the footer',
        }),
    footer__selection_new_releases: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'app.i18n.355e2c62964f00260154acb18bbaccdb',
            defaultMessage: 'New Releases',
            description: 'Selection item in footer - New Releases',
        }),
    footer__selection_must_watch: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'app.i18n.48ffb2007edadbf17abbbfe7801c04af',
            defaultMessage: 'Must-Watch',
            description: 'Selection item in footer - Must-Watch',
        }),
    footer__selection_forever_favorites: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'app.i18n.f4f14ece67a25b468722c45384ca89c9',
            defaultMessage: 'Forever Favorites',
            description: 'Selection item in footer - Forever Favorites',
        }),
    footer__selection_recently_added: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'app.i18n.e1a444c57a59c310dfd913b8fbbcaa70',
            defaultMessage: 'Recently Added',
            description: 'Selection item in footer - Recently Added',
        }),
    footer__selection_binge_watch: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'app.i18n.65fb3a2dd161458cb0d9221906dfc7e7',
            defaultMessage: 'Binge-Watch',
            description: 'Selection item in footer - Binge-Watch',
        }),
    footer__selection_only_on_yango: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'app.i18n.2a52d72d6283d65aeff89b4060322fc7',
                defaultMessage: 'Only on {brandName}',
                description: 'Selection item in footer - Only on {brandName}',
            },
            { brandName }
        ),
    footer__selection_made_in_egypt: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'app.i18n.2cafbb47b6a3b02717f84a571b08ff76',
            defaultMessage: 'Made in Egypt',
            description: 'Selection item in footer - Made in Egypt',
        }),
    footer__also_promo_code: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'app.i18n.6a3e483671513661502404b30c74db29',
            defaultMessage: 'Activate Promo Code',
            description: 'Link text in Also section of footer - Activate Promo Code',
        }),
    footer__also_yasmina: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'app.i18n.c54a8645b2a3a1933b9a4c7fedb2f6db',
            defaultMessage: 'Yasmina AI Speaker',
            description: 'Link text in Also section of footer - Yasmina AI Speaker',
        }),
    footer__also_yango_music: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'app.i18n.d7f4bdace1c2de60459730e7e73f8f2e',
            defaultMessage: 'Yango Music',
            description: 'Link text in Also section of footer - Yango Music',
        }),
};
